<template>
    <div>
        <div v-if="price">
            <refill-package-small />

            <div class="mt-2">
                <div v-if="existingCard">
                    <refill-existing-card />
                </div>
                <div v-else>
                    <hosted-checkout-form />
                </div>
            </div>
        </div>
        <div v-else>
            <refill-prices :prices="creditRefillPrices" />
        </div>
    </div>
</template>

<script>
import { mapState } from "vuex";

import RefillPrices from "@/components/wallet/refill/RefillPrices";
import RefillPackageSmall from "@/components/wallet/refill/RefillPackageSmall";
import RefillExistingCard from "@/components/wallet/refill/authorize/RefillExistingCard";
import HostedCheckoutForm from "@/components/wallet/refill/authorizeHosted/HostedCheckoutForm";

export default {
    computed: {
        existingCard() {
            return this.onboardingUser.authorizeProfile && !this.createCard;
        },
        ...mapState({
            onboardingUser: (state) => state.onboarding.user,
        }),
        ...mapState("options", ["creditRefillPrices"]),
        ...mapState("wallet", ["price", "createCard"]),
    },
    components: {
        RefillPrices,
        RefillPackageSmall,
        RefillExistingCard,
        HostedCheckoutForm,
    },
};
</script>
